module.exports = __webpack_public_path__ + "media/images/plans/e-photo_location/e-photo_location-4-5020bae74e9d00ecdee8067bd8d9eb61.png";